import React, { useContext } from 'react';
import { useNavigate, useParams } from 'react-router';

import { DASHBOARD } from '../../../../routes/routeConstants';
import StatusCell from '../../../Badge/StatusCell';
import ExitReviewIcon from '../../../Icons/ExitReviewIcon';
import Table from '../../../Table/Table';
import ActionRowWithModal from '../../../Table/TableAccessories/ActionRowWithModal';
import TableHasConflictTag from '../../../Table/TableAccessories/TableHasConflictTag';
import TableScroller from '../../../Table/TableScroller';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';
import PlainSuccessModal from '../../PlainSuccessModal';
import ReviewModal from '../ReviewModal/ReviewModal';

const DispatcherPreviousCompanyModal = () => {
  const modalContext = useContext(ModalContext);
  const { ninNumber } = useParams();
  const navigate = useNavigate();

  const successActionFn = () => {
    modalContext?.setShowModal(false);
    navigate(`/${DASHBOARD}`);
  };

  return (
    <ModalContainer
      width={!modalContext?.showSuccessComponent ? '867px' : undefined}
      label='View Previous Companies'
      successComponent={() => (
        <PlainSuccessModal
          successActionFn={successActionFn}
          description='The driver has been successfully hired.'
          btnLabel='Go to Dashboard'
          // className='pink'
        />
      )}
      showSuccessComponent={modalContext?.showSuccessComponent}
    >
      <TableScroller>
        <Table
          className='scrollable-table'
          tableHeader={{
            'Name of Company': 'companyName',
            Phone: 'phoneNumber',
            'Start Date': 'startDate',
            'End Date': 'endDate',
            'Hiring Type': 'employmentType',
          }}
          tableDataSourceUrl={`api/v1/dispatchers/previous-companies?nin=${ninNumber}`}
          moreOptionsComponents={[
            <ActionRowWithModal
              key='Exit Review'
              label='Exit Review'
              width='173px'
              icon={<ExitReviewIcon />}
              modalCompFn={(data) => <ReviewModal data={data} />}
            />,
          ]}
          cellsCustomComp={{
            hiringEligibility: <StatusCell statusKey='hiringEligibility' />,
            companyName: (
              <TableHasConflictTag
                dataKey='companyName'
                totalConflictsKey='triggeredConflict'
                isRehiredKey='rehired'
              />
            ),
          }}
          // showPaginationControl={false}
          continuousView
        />
      </TableScroller>
    </ModalContainer>
  );
};

export default DispatcherPreviousCompanyModal;
